import { createReducer, on } from "@ngrx/store";
import { initialState } from "../states/features.state";
import { getPanelistPoints, updatePanelistPointData } from "../actions/features.actions";



export const featuresReducer = createReducer(
  initialState,

  on(getPanelistPoints.loadPanelistPoints, (state, payload) => {
    
    switch (payload.status) {
      case 'request':
        return { ...state, loading: true };
      case 'success':
        return { ...state, loading: false, panelistPoints: payload?.data , success: true, message: 'Point get successfully' };
      case 'error':
        return { ...state, loading: false, panelistPoints: payload?.error.data , success: false, message: 'Point History not found' };
      default:
        return state;
    }
  }),

    on(updatePanelistPointData, (state, {data}) =>({
      ...state,
        panelistPoints: null
      })),
);